window.bldev = {}

export function registerDevTool (name, fn) {
  window.bldev[name] = fn
}

export function unregisterDevTool (name) {
  delete window.bldev[name]
}
